<template>
    <div>
        <div class="site-wrapper no-header">
            <div class="container">
                <h3 class="is-size-5">All OffshoreSMS Fleets *NEW</h3>
                <hr />
                <div class="columns">
                    <div class="column is-fullwidth">
                        <div class="checkbox-wrapper">
                            <div class="field">
                                <input class="is-checkradio" type="checkbox" id="showFleetBilled" v-model="showFleetBilled" />
                                <label for="showFleetBilled">Only show fleet billed fleets</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-fullwidth">
                        <div class="fleet-wrapper">
                            <div class="fleet-item" v-for="(fleet, index) in filteredFleets" :key="`fleet-${index}`">
                                <div class="details-wrapper">
                                    <div class="fleet-name">
                                        <div>
                                            {{ fleet.companyName }}
                                            <span v-if="fleet.assetReloadBin.length > 0">({{ fleet.assetReloadBin.length }})</span>
                                            <span v-if="fleet.fleetBillingEnabled" class="tag is-warning">
                                                <font-awesome-icon icon="star" /> &nbsp;Fleet Billed!
                                            </span>
                                        </div>
                                    </div>
                                    <div v-if="fleet.show">
                                        <hr />
                                        <p>Fleet ID: {{ fleet.id }}</p>
                                        <div class="spacer s10"></div>
                                        <div v-if="fleet.loading">Loading stats...</div>
                                        <div v-else class="stats notification">
                                            <p>Admins: {{ fleet.admins }}</p>
                                            <p>Assets: {{ fleet.assets }}</p>
                                            <p>Last Activity: {{ fleet.lastActivity }}</p>
                                        </div>
                                        <div class="buttons">
                                            <span class="button is-small is-warning" @click="postNotification(fleet)">
                                                <font-awesome-icon icon="exclamation-triangle" /> &nbsp;System Notification
                                            </span>
                                            <span class="button is-small is-warning" @click="getStats(fleet)">
                                                <font-awesome-icon icon="exclamation-triangle" /> &nbsp;Load Stats
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="fleet-buttons">
                                    <span
                                        class="btn tooltip"
                                        :class="[
                                            fleet.billingRenewalActive == undefined ? 'red' : fleet.billingRenewalActive == true ? 'orange' : 'grey'
                                        ]"
                                        @click="
                                            selectedFleet = fleet;
                                            resetBillingRenewal(index);
                                        "
                                    >
                                        <span class="tooltiptext tooltip-top">
                                            Set billingRenewalActive to
                                            {{
                                                fleet.billingRenewalActive == undefined
                                                    ? 'false'
                                                    : fleet.billingRenewalActive == true
                                                    ? 'false'
                                                    : 'true'
                                            }}</span
                                        >
                                        <font-awesome-icon
                                            :icon="
                                                fleet.billingRenewalActive == undefined
                                                    ? 'exclamation-triangle'
                                                    : fleet.billingRenewalActive == true
                                                    ? 'redo-alt'
                                                    : 'check'
                                            "
                                        />
                                    </span>
                                    <span
                                        class="btn tooltip"
                                        :class="[fleet.hasAlgoliaIndex == undefined ? '' : !fleet.hasAlgoliaIndex ? 'red' : 'green']"
                                        @click="
                                            selectedFleet = fleet;
                                            checkAlgolia();
                                        "
                                    >
                                        <span class="tooltiptext tooltip-top">Check if in Algolia</span>
                                        <font-awesome-icon icon="search" />
                                    </span>
                                    <span
                                        class="btn tooltip"
                                        :class="[updatedFleets.includes(fleet.id) ? 'green' : '']"
                                        @click="
                                            selectedFleet = fleet;
                                            updateAlgolia();
                                        "
                                    >
                                        <span class="tooltiptext tooltip-top">Re-add to index in Algolia</span>
                                        <font-awesome-icon :icon="!updatedFleets.includes(fleet.id) ? 'minus' : 'check'" />
                                    </span>
                                    <span class="btn tooltip" @click="fleet.show = !fleet.show">
                                        <span class="tooltiptext tooltip-top">{{ fleet.show ? 'Hide Details' : 'Show Details' }}</span>
                                        <font-awesome-icon :icon="fleet.show ? 'chevron-up' : 'chevron-down'" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <simple-modal :title="selectedFleet.companyName" theme="is-primary" submitText="Cancel" @closed="close()" v-if="showPostNotification">
            {{ selectedFleet }}
        </simple-modal> -->

        <simple-modal
            :title="'Post System Notification for: ' + selectedFleet.companyName"
            theme="is-primary"
            submitText="Cancel"
            @closed="close()"
            v-if="showPostNotification"
        >
            <label class="label">Notification Details:</label>
            <textarea class="textarea" cols="30" rows="5" v-model="newNotification.details"></textarea>
            <div class="spacer s20"></div>

            <label class="label">Optional Link:</label>
            <input class="input padded" type="text" placeholder="Paste any link.." v-model="newNotification.link" />
            <div class="spacer s20"></div>

            <label class="label">Type of Notification:</label>
            <div class="select">
                <select v-model="newNotification.type">
                    <option v-for="option in notificationTypes" :value="option.slug" :key="option.slug">{{ option.label }}</option>
                </select>
            </div>
            <div class="spacer s20"></div>

            <div class="">
                <input class="is-checkradio" type="checkbox" id="nnSendEmails" v-model="newNotification.sendEmails" />
                <label for="nnSendEmails"> Send emails to fleet admins</label>
            </div>
            <div class="spacer s20"></div>

            <div v-if="newNotification.sendEmails">
                <input class="is-checkradio" type="checkbox" id="nnSendTextMsg" v-model="newNotification.sendTextMsg" />
                <label for="nnSendTextMsg"> Also send SMS messages to fleet admins</label>
            </div>
            <div v-if="newNotification.sendEmails" class="spacer s20"></div>

            <div class="">
                <input class="is-checkradio" type="checkbox" id="nnUpdatedate" v-model="newNotification.updateDate" />
                <label for="nnUpdatedate"> Mark as most recent notification date</label>
            </div>
            <div class="spacer s20"></div>
            <div class="buttons">
                <span class="button is-success" :disabled="newNotification.details == ''" @click="sendNotification()">
                    <font-awesome-icon icon="envelope" /> &nbsp;Post Notification
                </span>
            </div>
            <div class="spacer s20"></div>
        </simple-modal>
    </div>
</template>

<script>
import firebase from 'firebase/compat/app';
import { db } from '../main.js';
import 'firebase/compat/auth';
// import 'firebase/firestore';
import 'firebase/compat/functions';
import NProgress from 'nprogress';
const SimpleModal = () => import('../reusables/SimpleModal.vue');
import algoliasearch from 'algoliasearch';

import { doc, updateDoc, Timestamp } from 'firebase/firestore';

let unsubscribe;

export default {
    name: 'AllFleetsNew',
    components: {
        SimpleModal
    },
    mounted() {
        this.loadFleets();
        // this.getToken();
    },
    unmounted() {
        if (unsubscribe) {
            unsubscribe();
        }
    },

    computed: {
        filteredFleets() {
            return this.showFleetBilled ? this.allFleets.filter(m => m.fleetBillingEnabled) : this.allFleets;
        },
        withBins() {
            return this.allFleets.filter(m => m.assetReloadBin && m.assetReloadBin.length > 0);
        }
    },

    data() {
        return {
            allFleets: [],
            selectedFleet: {},
            updatedFleets: [],
            showFleetBilled: false,
            showPostNotification: false,
            newNotification: {
                details: '',
                link: '',
                type: 'recommendation',
                sendEmails: false,
                sendTextMsg: false,
                updateDate: true
            },
            notificationTypes: [
                { slug: 'notice', label: 'General Notice' },
                { slug: 'alert', label: 'OffshoreSMS Alert' },
                { slug: 'tip', label: 'Helpful Tip' },
                { slug: 'recommendation', label: 'Recommendation' },
                { slug: 'update', label: 'Development Update' },
                { slug: 'billing', label: 'Billing Alert' }
            ]
        };
    },

    methods: {
        // getToken() {
        //     let self = this;
        //     firebase
        //         .auth()
        //         .currentUser.getIdToken(true)
        //         .then(function(idToken) {
        //             // Send token to your backend via HTTPS
        //             console.log('Token refreshed', idToken);
        //             // self.token = idToken;
        //         })
        //         .catch(function(error) {
        //             console.log('Error getting token', error);
        //         });
        // },

        close() {
            this.showPostNotification = false;
            this.newNotification = {
                details: '',
                link: '',
                type: 'recommendation',
                sendEmails: false,
                sendTextMsg: false,
                updateDate: true
            };
        },

        async loadFleets() {
            NProgress.start();
            db.collection('companies')
                .orderBy('companyName', 'asc')
                .get()
                .then(querySnapshot => {
                    this.allFleets = [];
                    querySnapshot.forEach(doc => {
                        let data = doc.data();
                        data.id = doc.id;
                        data.show = false;
                        data.hasAlgoliaIndex = doc.data().hasAlgoliaIndex;
                        data.billingRenewalActive = doc.data().billingRenewalActive;
                        data.updated = false;
                        data.assetReloadBin = doc.data().assetReloadBin ? doc.data().assetReloadBin : false;
                        // data.algoliaObjectID = doc.data().algoliaObjectID ? doc.data().algoliaObjectID : '';
                        let expired = doc.data().isExpired ? doc.data().isExpired : false;
                        data.fleetBillingEnabled = doc.data().fleetBillingEnabled ? doc.data().fleetBillingEnabled : false;
                        if (!expired) this.allFleets.push(data);
                    });
                    NProgress.done();
                });
        },

        postNotification(fleet) {
            console.log(fleet);
            this.selectedFleet = fleet;
            this.showPostNotification = true;
        },

        async sendNotification() {
            console.log(this.selectedFleet, this.newNotification);
            this.showPostNotification = false;
            let details = this.newNotification.details;
            if (this.newNotification.link != '') {
                details = this.newNotification.details + '\n' + this.newNotification.link;
            }
            console.log('Details', details);
            NProgress.start();
            db.collection('companies')
                .doc(this.selectedFleet.id)
                .collection('systemNotifications')
                .add({
                    details: this.newNotification.details,
                    type: this.newNotification.type,
                    sendEmails: this.newNotification.sendEmails,
                    sendTextMsg: this.newNotification.sendTextMsg,
                    updateDate: this.newNotification.updateDate,
                    viewedIDs: [],
                    archived: false,
                    timestamp: new Date()
                })
                .then(docRef => {
                    if (this.newNotification.updateDate) {
                        db.collection('companies')
                            .doc(this.selectedFleet.id)
                            .update({
                                lastSystemNotificationDate: new Date(),
                                lastSystemNotificationID: docRef.id
                            });
                    }
                })
                .then(() => {
                    if (this.newNotification.sendEmails) {
                        // send emails to fleet admins
                        var emailFleetAdminsWithParams = firebase.functions().httpsCallable('cf_teams-emailFleetAdminsWithParams');
                        emailFleetAdminsWithParams({
                            fleetID: this.selectedFleet.id,
                            message: details,
                            senderEmail: 'alerts@offshoresms.com.au',
                            subject: 'Billing Notification from OffshoreSMS',
                            alsoSendSms: this.newNotification.sendTextMsg
                        });
                    }
                })
                .then(() => {
                    if (this.newNotification.type == 'billing') {
                        let action = 'Billing alert created in fleet notifications';
                        if (this.newNotification.sendEmails) {
                            action += ' (fleet admins notified)';
                        }
                        db.collection('companies')
                            .doc(this.selectedFleet.id)
                            .collection('billingTimeline')
                            .add({
                                action: action,
                                timestamp: new Date(),
                                userID: 'system',
                                userName: 'OffshoreSMS Billing'
                            });
                    }
                })
                .then(() => {
                    NProgress.done();
                    this.close();
                });
        },

        async resetBillingRenewal(index) {
            // console.log(this.selectedFleet.id, this.filteredFleets[index].id);
            let value = this.selectedFleet.billingRenewalActive == undefined ? false : this.selectedFleet.billingRenewalActive == true ? false : true;
            NProgress.start();
            await updateDoc(doc(db, 'companies', this.selectedFleet.id), {
                billingRenewalActive: value
            })
                .then(() => {
                    console.log('Billing renewal reset for fleet:', this.selectedFleet.companyName);
                })
                .catch(error => {
                    console.error('Error resetting billing renewal:', error);
                });
            this.filteredFleets[index].billingRenewalActive = value;
            NProgress.done();
        },

        async checkAlgolia() {
            let searchClient = algoliasearch('789GF6G7HW', '0dfd28f6ac249c3ebef88e13f6adbc34');
            let searchIndex = searchClient.initIndex('app_fleets');

            // if (this.selectedFleet.algoliaObjectID == '') return;
            NProgress.start();
            let self = this;
            // this.selectedFleet.hasIndex = false;

            console.log(this.selectedFleet.id);
            setTimeout(() => {
                searchIndex
                    .getObject(self.selectedFleet.id)
                    .then(async object => {
                        await db
                            .collection('companies')
                            .doc(self.selectedFleet.id)
                            .update({
                                hasAlgoliaIndex: true
                            });
                        NProgress.done();
                    })
                    .catch(async err => {
                        console.log(err);
                        console.log('No user index found');
                        await db
                            .collection('companies')
                            .doc(self.selectedFleet.id)
                            .update({
                                hasAlgoliaIndex: false
                            });
                        NProgress.done();
                    });
            }, 200);
        },

        updateAlgolia() {
            let self = this;
            let searchClient = algoliasearch('789GF6G7HW', '0dfd28f6ac249c3ebef88e13f6adbc34');
            let searchIndex = searchClient.initIndex('app_fleets');
            NProgress.start();
            let fleet = {};
            fleet.objectID = this.selectedFleet.id;
            fleet.fleetID = this.selectedFleet.id;
            fleet.fleetName = this.selectedFleet.companyName;
            fleet.fleetLocation = this.selectedFleet.fleetLocation ? this.selectedFleet.fleetLocation : this.selectedFleet.companyLocation;
            fleet.isExpired = this.selectedFleet.isExpired ? this.selectedFleet.isExpired : false;
            fleet.isEnterprise = this.selectedFleet.isEnterprise ? this.selectedFleet.isEnterprise : false;
            searchIndex
                .saveObject(fleet)
                .then(async object => {
                    console.log('object', object);
                    await db
                        .collection('companies')
                        .doc(self.selectedFleet.id)
                        .update({
                            hasAlgoliaIndex: true
                        });
                    self.updatedFleets.push(self.selectedFleet.id);
                    NProgress.done();
                })
                .catch(async err => {
                    console.log(err);
                    console.log('Error creating/updating fleet object');
                    NProgress.done();
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.tags {
    &.mt-3 {
        margin-top: 3px;
    }
}
.fleet-wrapper {
    .fleet-item {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 10px;
        border: 1px solid #e4e4e4;
        border-radius: 3px;
        margin-bottom: 5px;
        .details-wrapper {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }
        .fleet-buttons {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 150px;
            .btn {
                background-color: #e4e4e4;
                color: #222;
                padding: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                cursor: pointer;
                &.red {
                    background-color: red;
                    color: #fff;
                }
                &.green {
                    background-color: mediumseagreen;
                    color: #fff;
                }
                &.orange {
                    background-color: orange;
                    color: #fff;
                }
            }
        }
    }
}
</style>
